module.exports = __webpack_public_path__ + "img/antes_despues_296.34a47e49.png";